module.exports = __webpack_public_path__ + "img/streches.b7af58f4.png";